import { useDebounceValue } from 'usehooks-ts'

import { useQuerySmartSearch } from '../../hooks/useQuerySmartSearch.js'
import {
  ResultsView,
  SmartSearchEntityType,
  SmartSearchFilters,
} from '../../SmartSearch.types.js'
import { NoResults } from './NoResults.js'
import { SmartSearchResultsSection } from './SmartSearchResultsSection.js'

interface Props {
  filters: SmartSearchFilters
  setFilters: (filters: SmartSearchFilters) => void
  view: ResultsView
}

export const AiPoweredSearchResults = ({
  filters,
  setFilters,
  view,
}: Props) => {
  const { query, type, spaceIds } = filters
  const [debouncedQuery] = useDebounceValue(query, 500)

  const {
    postsQuery,
    membersQuery,
    spacesQuery,
    externalsSearchQuery,
    hasResultsByType,
  } = useQuerySmartSearch({
    query: debouncedQuery,
    date: filters.date,
    tagsId: filters.tagsId,
    type,
    spaceIds,
  })

  if (!query) {
    return null
  }

  const showNoResults = hasResultsByType(type) === false

  const handleSwitchToSolely = (type: SmartSearchEntityType) => {
    setFilters({ ...filters, type })
  }

  if (showNoResults) {
    return <NoResults query={query} type={type} />
  }

  const items = [
    {
      type: SmartSearchEntityType.POSTS,
      queryResult: postsQuery,
    },
    {
      type: SmartSearchEntityType.SPACES,
      queryResult: spacesQuery,
    },
    {
      type: SmartSearchEntityType.MEMBERS,
      queryResult: membersQuery,
    },
    {
      type: SmartSearchEntityType.EXTERNALS,
      queryResult: externalsSearchQuery,
    },
  ]

  return (
    <>
      {items.map(item =>
        !type || type === item.type ? (
          <SmartSearchResultsSection
            key={item.type}
            type={item.type}
            queryResult={item.queryResult}
            query={query}
            view={view}
            spaceIds={spaceIds}
            onSwitchToSolely={handleSwitchToSolely}
          />
        ) : null,
      )}
    </>
  )
}
